import { createBrowserRouter } from 'react-router-dom';
import { routes } from './router/routes';
import { setRouter } from '@/shared/lib/routerRef';

/**
 * Application Router
 *
 * Uses createBrowserRouter for improved performance and features:
 * - Better route matching before rendering
 * - Built-in error boundaries
 * - Support for data loaders and actions
 * - Improved TypeScript support
 */
export const router = createBrowserRouter(routes);

// Register in singleton so axios / auth providers can navigate without dynamic import.
setRouter(router);

